import request from '@/api/request'

export default {
  async getColors () {
    return (await request.get(`module/action/marketplace/decathlon/color`)).data
  },
  async getSizes () {
    return (await request.get(`module/action/marketplace/decathlon/size`)).data
  },
  async getCategories () {
    return (await request.get(`module/action/marketplace/decathlon/category/retrieve`)).data
  },
  async getBrands () {
    return (await request.get(`module/action/marketplace/decathlon/brand/retrieve`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/decathlon/index.js